import Vue from 'vue';
import Vuex from 'vuex';

// import stocks from './modules/stocks';
// import portfolio from './modules/portfolio';

import * as actions from './actions';
import * as mutations from './mutations';
import VuexPersistence from 'vuex-persist'

//@TODO - Base on performance / usability, we may have to add the reducer which allows you to "whitelist" which parts of the data will actually persist to localStorage
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  //reducer: (state) => ({})
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menu: {
      categories: [],
      products: [],
      deals: [],
      abouts: [],
    },
    garage: {
      myVehicles: [],
      carYears: [],
      carMakes: [],
    },
    promotion: {
      id: null,
      name: null,
      alias: null,
      promotion_expiration: null,
      coupon_stores: []
    },
    user: {
      leadId: null,
      userSearchLocation: null,
      search_results: [],
      selectedStoreForInquiry: null,
      ppc_store: null,
      ppc_form_type: 'quote',
      campaign: null,
      first_name: null,
      last_name: null,
      email: null,
      phone: null,
      service_category: null, //should just track via ID
      services: [], //just going to track via ID
      ppc_service: null,
      service_object_type: null, //deprecate
      products: [],
      page_url: null,
      requested_appointment: null,
      requested_appointment_date: null,
      requested_appointment_time: null,
      notes: null,
      vehicle: {
        year: null,
        make: null,
        model: null,
        doors: null
      },
      marine_type: null,
      commercial_type: null,
      residential_type: null,
      off_site: false,
      address: {
        street: null,
        street_2: null,
        city: null,
        region: null,
        postal_code: null
      }
    },
    ppc_disabled_dates: [],
    ppc_disabled_to: null,
    ppc_disabled_from: null,
    form_processing: false,
    critical_form_error: false,
    form_response: {
      responseCode: null,
      responseErrors: null,
      responseHeadline: null,
      responseMessage: null,
      responseDetails:null,
      transactionID: null
    },
    components: {
      menu: {
        mobileMenuOpen1: false,
        selectedMenu1: '',
        mobileMenuOpen2: false,
        selectedMenu2: '',
        menu2Items: [],
        menu3Items: [],
      },
      modalActive: false,
      checkout: {
        active:false,
        current_step: 1,
        steps: [
          {
            name: 'checkout_store',
            label: 'Store',
            full_label: 'Select a Store',
            id: 1,
            complete: false,
            active: true
          },
          {
            name: 'appt_contact',
            label: 'Contact Info',
            full_label: 'Contact Info',
            id: 3,
            complete: false,
            active: false
          },
          {
            name: 'appt_confirm',
            label: 'Confirm',
            full_label: 'Finalize Quote Request',
            id: 4,
            complete: false,
            active: false
          }
        ]
      },
      appointment: {
        active: false,
        current_step: 1,
        form_validated: false,
        validation_failed: false,
        form_complete: false,
        dates_loading: false,
        dates_loaded: false,
        availability_queried: null,
        availability: [],
        errors: null,
        steps: [
          {
            name: 'appt_store',
            label: 'Store',
            full_label: 'Select a Store',
            id: 1,
            complete: false,
            active: true
          },
          {
            name: 'appt_service',
            label: 'Services',
            full_label: 'Select Your Service(s)',
            id: 2,
            complete: false,
            active: false
          },
          {
            name: 'appt_date',
            label: 'Date / Time',
            full_label: 'Select Your Date & Time',
            id: 3,
            complete: false,
            active: false
          },
          {
            name: 'appt_contact',
            label: 'Contact Info',
            full_label: 'Contact Info',
            id: 4,
            complete: false,
            active: false
          },
          {
            name: 'appt_confirm',
            label: 'Confirm',
            full_label: 'Appointment Request Details',
            id: 5,
            complete: false,
            active: false
          }
        ],
      },
      quote: {
        active: false,
        current_step: 'quote_store',
        complete: false,
        validation_failed: false,
        errors: null,
        steps: [
          {
            name: 'quote_store',
            label: 'Store',
            id: 1,
            complete: false,
            active: true
          },
          {
            name: 'quote_service',
            label: 'Services',
            id: 2,
            complete: false,
            active: false
          },
          {
            name: 'quote_contact',
            label: 'Contact Info',
            id: 3,
            complete: false,
            active: false
          },
          {
            name: 'quote_confirm',
            label: 'Confirm',
            id: 4,
            complete: false,
            active: false
          }
        ]
      }
    },

    /* menus */
    categories: [],
    products: [],
    deals: [],
    abouts: [],
    /* Vehicle Lookup Data */
    myVehicles: [],
    carYears: [],
    carMakes: [],
    /** location */
    myStore: null,
    storeResults: [],
    primaryVehicle: {
      year: null,
      make: null,
      model: null,
      doors: null
    },
    // Setup Support for Product Modal
    // userLocation: {},
    // searchLocation: '',
    regions: [],
    /** mobile menu nav */
    mobileMenuOpen1: false,
    selectedMenu1: '',
    mobileMenuOpen2: false,
    selectedMenu2: '',
    menu2Items: [],
    menu3Items: [],
    /* appointment modal */
    appointment_modal: false,
    appt_cur_stage: 'appt_store', // appt_store | appt_service | appt_date | appt_contact | appt_confirm | appt_book
    appointment: {
      store: null,
      service: null,
      datetime: null,
      contact: null,
    },
    form_service_options: null,
    appt_options_marine: ['Under 20 Feet','20 to 30 Feet','30 to 40 Feet','Over 40 Feet','Other'],
    appt_options_residential: ['Single Family 1-Story','Single Family 2-Story','Multi-Family','Townhouse','Condominium','Apartment','Other'],
    appt_options_commercial: ['Office Building','Retail Storefront','Strip Center','Restaurant','Hotel','Other'],
    /** quote modal */
    quote_modal: false,
    quote_cur_stage: 'quote_store', // quote_store | quote_service | quote_date | quote_contact | quote_confirm | quote_book
    quote: {
      store: null,
      service: null,
      contact: null,
    },
    //@TODO - Normalize Quote / Appointment functions that don't need to be separated
    //@TODO - Remove all unused data segments / points that are no longer needed
    quote_options_marine: [],
    quote_options_residential: [],
    quote_options_commercial: [],
  },
  getters: {
    quoteErrors: state => {
      if(state.components.quote.errors == null){
        return false;
      }
      return Object.keys(state.components.quote.errors);
      //return state.components.quote.errors;
      //@TODO - We could attempt to map out the validation errors to their specific areas
    },
    appointmentErrors: state => {
      if(state.components.appointment.errors == null){
        return false;
      }
      //return Object.keys(state.components.appointment.errors);
      return state.components.appointment.errors;
    },
    errorHighlighter: (state,getters) => {
      if(getters.quoteErrors){
        //let storeError = [];
        ///let serviceError = [];
        //let contactError = ['first_name','last_name','email','phone'];
        getters.quoteErrors.forEach(function(item){
          //@TODO - We'll look to make this more advanced
          if(item == 'first_name' ||
              item == 'last_name' ||
              item == 'email' ||
              item == 'phone'
          ){
            console.log('formContact has validation error');
            return true;
          }
        });
      }
    },
    validQuoteState: (state,getters) => {
     if(!getters.formStore){
       return 0;
     }
     if(!getters.formServices){
       return 1;
     }
     if(!getters.formContact){
       return 2;
     }
     return false;
    },
    validAppointmentState: (state,getters) => {
      if(!getters.formStore){
        return 0;
      }
      if(!getters.formServices){
        return 1;
      }
      if(!getters.formAppointment){
        return 2;
      }
      if(!getters.formContact){
        return 3;
      }
      return false;
    },
    userVehicles: state => {
      if(state.myVehicles.length <= 1){
        return false;
      }
      return state.myVehicles[1].children;
    },
    appointmentLabel: state => {
      if(state.user.requested_appointment_date !== null && state.user.requested_appointment_time !== null){
        return state.user.requested_appointment_date.dayOfWeekProper+', '+state.user.requested_appointment_date.month+' '+state.user.requested_appointment_date.dateOfWeekProper+' @ ' + state.user.requested_appointment_time.label;
      }
      return false;
    },
    totalQuoteSteps: state => {
      return state.components.appointment.steps.length;
    },
    // var current_step = state.components.appointment.steps.findIndex(item => item.active == true);
    //     var total_steps = state.components.appointment.steps.length;
    currentAppointmentState: state => {
      var result = state.components.appointment.steps.filter(item => item.active == true);
      if(result.length == 0){
        return state.components.appointment.steps[0];
      }
      return result[0];
    },
    currentQuoteState: state => {
      var result = state.components.quote.steps.filter(item => item.active == true);
      return result[0];
    },
    appointmentStep: state => {
      let current_step = state.components.appointment.current_step;
      var result = state.components.appointment.steps.filter(item => item.id == current_step);
      return result[0];
    },
    formStore: state => {
      if(state.user.selectedStoreForInquiry !== null){
        return state.user.selectedStoreForInquiry;
      }
      return false;
    },
    formServices: state => {
      if(state.user.services.length > 0){
        return true;
      }
      return false;
    },
    formAppointment: state => {
      if(state.user.requested_appointment_date !== null && state.user.requested_appointment_time !== null){
        return true;
      }
      return false;
    },
    formEmail: state => {
      if(state.user.email == null){
        return false;
      }
      let testEmail = state.user.email.toLowerCase().match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
      if(testEmail){
        return true;
      } else {
        return false;
      }
    },
    formContact: (state,getters) => {
      if(state.user.first_name == null){
        return false;
      }
      if(state.user.last_name == null){
        return false;
      }
      if(state.user.email == null || !getters.formEmail){
        return false;
      }
      if(state.user.phone == null){
        return false;
      }
      if(state.user.notes == null){
        return false;
      }
      if(getters.hasAutomotive && !getters.userHasVehicle){
        return false;
      }
      if(getters.hasMarine && state.user.marine_type == null){
        return false;
      }
      if(getters.hasCommercial && state.user.commercial_type == null){
        return false;
      }
      if(getters.hasResidential && state.user.residential_type == null){
        return false;
      }
      if(state.user.off_site){
        return getters.offsiteValidated;
      }
      return true;
    },
    userServices: state => {
     return state.user.services.map((service) => service.category);
    },
    hasAutomotive: (state,getters) => {
      if(getters.userServices.indexOf('Automotive') !== -1){
        return true;
      }
      return false;
    },
    hasMarine: (state,getters) => {
      if(getters.userServices.indexOf('Marine') !== -1){
        return true;
      }
      return false;
    },
    hasCommercial: (state,getters) => {
      if(getters.userServices.indexOf('Commercial') !== -1){
        return true;
      }
      return false;
    },
    hasResidential: (state,getters) => {
      if(getters.userServices.indexOf('Residential') !== -1){
        return true;
      }
      return false;
    },
    userHasVehicle: (state,getters) => {
      if(!getters.hasAutomotive){
        return false;
      }
      if(state.user.vehicle.year == null){
        return false;
      }
      if(state.user.vehicle.make == null){
        return false;
      }
      if(state.user.vehicle.model == null){
        return false;
      }
      if(state.user.vehicle.doors == null){
        return false;
      }
      return true;
    },
    offsiteValidated: state => {
      if(!state.user.off_site){
        return true;
      } else {
        if(state.user.address.street == null){
          return false;
        }
        if(state.user.address.city == null){
          return false;
        }
        if(state.user.address.region == null){
          return false;
        }
        if(state.user.address.postal_code == null){
          return false;
        }
        return true;
      }
    },
    formOffsite: state => {
      if(state.user.off_site == false && state.user.address.street == null){
        return false;
      }
      return true;
    },
    appointmentFormComplete: (state,getters) => {
      if(getters.formStore && getters.formServices && getters.formAppointment && getters.formContact){
        return true;
      } else {
        return false;
      }
    },
    appointmentProcessedSuccessfully: (state) => {
      if(state.form_processing){
        return false;
      }
      if(state.form_response.responseCode == 1){
        return true;
      }
      return false;
    },
    quoteFormComplete: (state,getters) => {
      if(getters.formStore && getters.formServices && getters.formContact){
        return true;
      }
      return false;
    },
    quoteProcessedSuccessfully: (state,getters) => {
      if(state.form_processing){
        return false;
      }
      if(state.form_response.responseCode == 1 && getters.quoteFormComplete){
        return true;
      }
    },
    userHasStore: state => {
      if(state.user.selectedStoreForInquiry !== null || state.myStore !== null){
        return true;
      }
      return false;
    },
    userHasCart: state => {
      if(state.components.checkout.active){
        return true;
      }
    },
    getUserStorePhone: (state) => {
     if(state.user.selectedStoreForInquiry !== null){
       return state.user.selectedStoreForInquiry.mainPhone;
     }
     if(state.myStore.mainPhone !== null){
       return state.myStore.mainPhone;
     }
     return '';
    },
    ppc_services: (state) => {
      if(state.form_service_options == null){
        return [{id:0,text:'Please Select a Service*',value:null,disabled:true}];
      }
      let service_options = [{id:0,text:'Please Select a Service*',value:null,disabled:true}];
      if(state.user.service_category == 1){
        service_options = [].concat(service_options,state.form_service_options[0].core_services.map((service)=>({id:service.id,'text':service.alias_name,'value':service.id})));
        return service_options;
        //return state.form_service_options[0].core_services.map((service)=>({id:service.id,'text':service.name,'value':service.id}));
      }
      if(state.user.service_category == 2){
        service_options = [].concat(service_options,state.form_service_options[1].core_services.map((service)=>({id:service.id,'text':service.alias_name,'value':service.id})));
        return service_options;
      }
      if(state.user.service_category == 3){
        service_options = [].concat(service_options,state.form_service_options[2].core_services.map((service)=>({id:service.id,'text':service.alias_name,'value':service.id})));
        return service_options;
      }
      if(state.user.service_category == 4){
        service_options = [].concat(service_options,state.form_service_options[3].core_services.map((service)=>({id:service.id,'text':service.alias_name,'value':service.id})));
        return service_options;
      }
      return false;
    },
    appointmentFormData: (state,getters) => {
      if(!getters.appointmentFormComplete){
        return false;
      }
      let formData = new FormData();
      formData.append('formType','appointment');
      formData.append('store',state.user.selectedStoreForInquiry['location-id']);
      formData.append('first_name',state.user.first_name);
      formData.append('last_name',state.user.last_name);
      formData.append('email',state.user.email);
      formData.append('phone',state.user.phone);
      formData.append('page_url',state.user.page_url);
      //formData.append('services',state.user.services.filter(service => service.id));
      //formData.append('services',_.pluck(state.user.services,'id');
      formData.append('services',state.user.services.map((service) => service.id));
      formData.append('requested_appointment_date',state.user.requested_appointment_date.date);
      formData.append('requested_appointment_time',state.user.requested_appointment_time.label);
      formData.append('notes',state.user.notes);
      if(state.user.leadId !== null){
        formData.append('lead_id',state.user.leadId);
      }
      if(state.user.vehicle.year !== null){
        formData.append('year',state.user.vehicle.year);
        formData.append('make',state.user.vehicle.make);
        formData.append('model',state.user.vehicle.model);
        formData.append('doors',state.user.vehicle.doors);
      }
      if(state.user.residential_type !== null){
        formData.append('residential_type',state.user.residential_type);
      }
      if(state.user.commercial_type !== null){
        formData.append('commercial_type',state.user.commercial_type);
      }
      if(state.user.marine_type !== null){
        formData.append('marine_type',state.user.marine_type);
      }
      formData.append('off_site',state.user.off_site);
      if(state.user.off_site){
        if(state.user.address.street !== null){
          formData.append('street',state.user.address.street);
        }
        if(state.user.address.street_2 !== null){
          formData.append('street_2',state.user.address.street_2);
        }
        if(state.user.address.city !== null){
          formData.append('city',state.user.address.city);
        }
        if(state.user.address.region !== null){
          formData.append('region',state.user.address.region);
        }
        if(state.user.address.postal_code !== null){
          formData.append('postal_code',state.user.address.postal_code);
        }
      }
      return formData;
    },
    userCurrentForm: (state) => {
      if(state.components.appointment.active){
        return 'appointment';
      }
      if(state.components.quote.active){
        return 'quote';
      }
      return false;
    },
    quoteFormData: (state,getters) => {
      //@TODO - Should we only return / calculate this if the appt_form is active?
      if(!getters.quoteFormComplete){
        return false;
      }
      let formData = new FormData();
      formData.append('formType','quote');
      formData.append('store',state.user.selectedStoreForInquiry['location-id']);
      formData.append('first_name',state.user.first_name);
      formData.append('last_name',state.user.last_name);
      formData.append('email',state.user.email);
      formData.append('phone',state.user.phone);
      formData.append('page_url',state.user.page_url);
      formData.append('services',state.user.services.map((service) => service.id));
      formData.append('notes',state.user.notes);
      if(state.user.leadId !== null){
        formData.append('lead_id',state.user.leadId);
      }
      if(state.user.vehicle.year !== null){
        formData.append('year',state.user.vehicle.year);
        formData.append('make',state.user.vehicle.make);
        formData.append('model',state.user.vehicle.model);
        formData.append('doors',state.user.vehicle.doors);
      }
      if(state.user.residential_type !== null){
        formData.append('residential_type',state.user.residential_type);
      }
      if(state.user.commercial_type !== null){
        formData.append('commercial_type',state.user.commercial_type);
      }
      if(state.user.marine_type !== null){
        formData.append('marine_type',state.user.marine_type);
      }
      formData.append('off_site',state.user.off_site);
      if(state.user.off_site){
        if(state.user.address.street !== null){
          formData.append('street',state.user.address.street);
        }
        if(state.user.address.street_2 !== null){
          formData.append('street_2',state.user.address.street_2);
        }
        if(state.user.address.city !== null){
          formData.append('city',state.user.address.city);
        }
        if(state.user.address.region !== null){
          formData.append('region',state.user.address.region);
        }
        if(state.user.address.postal_code !== null){
          formData.append('postal_code',state.user.address.postal_code);
        }
      }
      return formData;
    },
    ppcAvailability: (state) => {
      let disabled_dates = [];
      let from = new Date(state.ppc_disabled_from);
      from.setDate(from.getDate()+1);
      state.ppc_disabled_dates.forEach(function(day){
        disabled_dates.push(new Date(day));
      });
      return {
        to: new Date(state.ppc_disabled_to),
        from: from,
        dates: disabled_dates
      }
    },
    ppcFormComplete: (state) => {
      if(state.user.first_name == null){
        return false;
      }
      if(state.user.last_name == null){
        return false;
      }
      if(state.user.email == null){
        return false;
      }
      if(state.user.phone == null){
        return false;
      }
      if(state.user.ppc_store == null){
        return false;
      }
      if(state.user.ppc_form_type == null){
        return false;
      }
      if(state.user.ppc_form_type == 'appointment'){
        if(state.user.requested_appointment_date == null){
          return false;
        }
        if(state.user.requested_appointment_time == null){
          return false;
        }
      }
      //@TODO - Add rules to handle vehicle selection, marine type selection, comm/res and other conditional fields
      if(state.user.ppc_service == null){
        return false;
      }
      return true;
      //@TODO - Could build modules for each of these, and inspect them granularly, will help readability and 'validation' finding/mapping
    },
    ppcFormErrors: (state) => {
      if(state.components.appointment.errors !== null || state.components.quote.errors !== null){
        return true;
      }
      return false;
    },
    ppcFormData: (state) => {
      let formData = new FormData();
      formData.append('siteArea','ppc');
      formData.append('formType',state.user.ppc_form_type);
      formData.append('store',state.user.ppc_store);
      formData.append('first_name',state.user.first_name);
      formData.append('last_name',state.user.last_name);
      formData.append('email',state.user.email);
      formData.append('phone',state.user.phone);
      formData.append('page_url',state.user.page_url);
      formData.append('services',state.user.ppc_service);
      formData.append('campaign',state.user.campaign);
      if(state.user.notes !== null){
        formData.append('notes',state.user.notes);
      }
      if(state.user.leadId !== null){
        formData.append('lead_id',state.user.leadId);
      }
      if(state.user.vehicle.year !== null){
        formData.append('year',state.user.vehicle.year);
        formData.append('make',state.user.vehicle.make);
        formData.append('model',state.user.vehicle.model);
        formData.append('doors',state.user.vehicle.doors);
      }
      if(state.user.residential_type !== null){
        formData.append('residential_type',state.user.residential_type);
      }
      if(state.user.commercial_type !== null){
        formData.append('commercial_type',state.user.commercial_type);
      }
      if(state.user.marine_type !== null){
        formData.append('marine_type',state.user.marine_type);
      }
      if(state.user.ppc_form_type == 'appointment'){
        if(state.user.requested_appointment_date !== null){
          let requested_date = new Date(state.user.requested_appointment_date);
          formData.append('requested_appointment_date',requested_date.toISOString());
        }
        if(state.user.requested_appointment_time !== null) {
          formData.append('requested_appointment_time', state.user.requested_appointment_time);
        }
      }
      return formData;
    }
  },
  mutations,
  actions,
  modules: {
      // stocks,
      // portfolio
  },
  plugins: [vuexLocal.plugin]
});
